import React, { createContext, useContext, useState, useEffect } from "react";

export const ResponsiveContext = createContext();

export const ResponsiveProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isPhoneLandscape, setIsPhoneLandscape] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [isCompactNav, setIsCompactNav] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setIsMobile(width < 600);
      setIsTablet(width >= 600 && width < 960);
      setIsDesktop(width >= 960);
      // Phone landscape: wider than tall, but short height (phones ≤500px tall in landscape)
      setIsPhoneLandscape(width > height && height <= 500);
      // Portrait orientation (tablet/phone held vertically; desktop monitors are usually landscape)
      setIsPortrait(height > width);
      // Nav has many items; collapse to hamburger below ~1100px so it never wraps/clips
      setIsCompactNav(width < 1100);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  const value = {
    isMobile,
    isTablet,
    isDesktop,
    isPhoneLandscape,
    isPortrait,
    isCompactNav,
  };

  return (
    <ResponsiveContext.Provider value={value}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export const useResponsive = () => {
  const context = useContext(ResponsiveContext);
  if (context === undefined) {
    throw new Error("useResponsive must be used within a ResponsiveProvider");
  }
  return context;
};
